<p-toolbar styleClass="">
  <ng-template pTemplate="left">
  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable()"
              pTooltip="Обновить таблицу" tooltipPosition="top"></p-button>

    <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
              pTooltip="Экспортировать список документов" tooltipPosition="top" [disabled]="!recordsList"></p-button>
  </ng-template>
</p-toolbar>

<p-table #ptable1 [value]="recordsList"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [loading]="loading"
         [showCurrentPageReport]="(totalRecords > 10)"
         [totalRecords]="totalRecords"
         [paginator]="(totalRecords > 10)"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} строк"
         sortMode="multiple"
         [multiSortMeta]="[{field: 'PRODCODE', order: 1}, {field: 'PARTCODE', order: 1}]"
         dataKey="PARTID"
         selectionMode="single"
         [(selection)]="selectedRecord"
         (onRowSelect)="onRecentRowSelect($event)"
         rowExpandMode="single"
         [rowHover]="true"
         [resizableColumns]="true"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestoreNew($event)"
         style="width:100%"
         styleClass="p-datatable-gridlines p-datatable-striped">

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width: 3rem">...</th>
      <th pResizableColumn pSortableColumn="PRODCODE" style="width: 35%">Изделие <p-sortIcon field="PRODCODE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PARTCODE" style="width: 25%">Часть <p-sortIcon field="PARTCODE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="STOCK" style="width: 8rem">На складе <p-sortIcon field="STOCK"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="REQNTY" style="width: 8rem">Требуется <p-sortIcon field="REQNTY"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="GIVEN" style="width: 8rem">Передано <p-sortIcon field="GIVEN"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="mSUM" style="width: 10rem">На сумму <p-sortIcon field="mSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DEBT" style="width: 8rem">Долг <p-sortIcon field="DEBT"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="fromST1" style="width: 8rem; word-wrap: break-word;">C основного <p-sortIcon field="fromST1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="fromST2" style="width: 8rem; word-wrap: break-word;">C импорта <p-sortIcon field="fromST2"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="fromST3" style="width: 8rem; word-wrap: break-word;">C заемного <p-sortIcon field="fromST3"></p-sortIcon></th>
    </tr>

    <tr>
      <th pResizableColumn style="width: 3rem">...</th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PRODCODE']" (input)="ptable1.filter($event.target.value, 'PRODCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PARTCODE']" (input)="ptable1.filter($event.target.value, 'PARTCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['STOCK']" (input)="ptable1.filter($event.target.value, 'STOCK', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['REQNTY']" (input)="ptable1.filter($event.target.value, 'REQNTY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['GIVEN']" (input)="ptable1.filter($event.target.value, 'GIVEN', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['mSUM']" (input)="ptable1.filter($event.target.value, 'mSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DEBT']" (input)="ptable1.filter($event.target.value, 'DEBT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['fromST1']" (input)="ptable1.filter($event.target.value, 'fromST1', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['fromST2']" (input)="ptable1.filter($event.target.value, 'fromST2', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['fromST3']" (input)="ptable1.filter($event.target.value, 'fromST3', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-recordsList let-expanded="expanded">
    <tr [pSelectableRow]="recordsList" [class.yellow]="recordsList.REQNTY>recordsList.GIVEN">
      <td>
        <button type="button" pButton pRipple [pRowToggler]="recordsList"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
      </td>
      <td><a [routerLink]="['/edit-product', recordsList.PRODID]">{{recordsList.PRODCODE}}</a></td>
      <td><a [routerLink]="['/edit-product', recordsList.PARTID]">{{recordsList.PARTCODE}}</a></td>
      <td style="text-align: right">{{recordsList.STOCK | number:'1.0-2' }}</td>
      <td style="text-align: right" [class.rednote]="recordsList.DEBT>recordsList.STOCK">{{recordsList.REQNTY | number:'1.0-2' }}</td>
      <td style="text-align: right">{{recordsList.GIVEN | number:'1.0-2' }}</td>
      <td style="text-align: right">{{recordsList.mSUM | number:'1.2-2' }}</td>
      <td style="text-align: right">{{recordsList.DEBT | number:'1.0-2' }}</td>
      <td style="text-align: right">{{recordsList.fromST1 | number:'1.0-2' }}</td>
      <td style="text-align: right">{{recordsList.fromST2 | number:'1.0-2' }}</td>
      <td style="text-align: right">{{recordsList.fromST3 | number:'1.0-2' }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td style="text-align: right"></td>
      <td style="text-align: right">{{sumREQNTY | number:'1.0-2' }}</td>
      <td style="text-align: right">{{sumGIVEN | number:'1.0-2' }}</td>
      <td style="text-align: right">{{summSUM | number:'1.2-2' }}</td>
      <td style="text-align: right">{{sumDEBT | number:'1.0-2' }}</td>
      <td style="text-align: right">{{sumFromST1 | number:'1.0-2' }}</td>
      <td style="text-align: right">{{sumFromST2 | number:'1.0-2' }}</td>
      <td style="text-align: right">{{sumFromST3 | number:'1.0-2' }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-recordsList>
    <tr>
      <td colspan="9">
        <div class="p-2">
          <app-document-content-table [selectedDocumentId]="recordsList.DOCID" [showFooterTotal]="true"></app-document-content-table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="9">На сегодня документов нет</td>
    </tr>
  </ng-template>
</p-table>
<!--<div class="fluid grid">
  <div class="col-12">
  </div>
</div>-->
